import { Box, Skeleton, Typography } from "@mui/material";
import Flex from "../../../../../components/Flex";
import {
  BILLING_KPI_CARDS,
  BillingKPICardConfig,
} from "./billing-report-constants";
import { CHART_TYPOGRAPHY } from "../../../../../components/app/provider/patient/chart";

interface BillingReportKPICardsProps {
  data: Record<string, any> | undefined;
  isLoading: boolean;
}

const VALUE_BOX_STYLE = {
  backgroundColor: "#CDF4F8",
  border: "1px solid #AEE7ED",
  borderRadius: "4px",
  padding: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
};

const formatValue = (value: any, format: BillingKPICardConfig["format"]) => {
  const num = value ?? 0;
  switch (format) {
    case "currency":
      return `$${Number(num).toLocaleString()}`;
    case "days":
      return `${num} days`;
    case "percent":
      return `${num} %`;
    case "number":
    default:
      return Number(num).toLocaleString();
  }
};

const KPICard = ({
  config,
  data,
  isLoading,
}: {
  config: BillingKPICardConfig;
  data: Record<string, any> | undefined;
  isLoading: boolean;
}) => {
  const value = data?.[config.valueKey] ?? 0;

  return (
    <Box
      sx={{
        border: "1px solid #E7E7E7",
        borderRadius: "4px",
        padding: "8px 12px",
        flex: "1 1 0",
        minWidth: 140,
        backgroundColor: "#FFFFFF",
      }}
    >
      {isLoading ? (
        <Flex justifyContent="space-between" alignItems="center">
          <Box flex={1}>
            <Skeleton width="80%" height={18} />
          </Box>
          <Skeleton width={50} height={35} variant="rounded" />
        </Flex>
      ) : (
        <Flex justifyContent="space-between" alignItems="center" gap="6px">
          <Box flex={1}>
            <Typography
              fontSize={CHART_TYPOGRAPHY.body5.fontSize}
              fontWeight={500}
              color="#373D41"
              lineHeight={1.2}
              whiteSpace="pre-line"
            >
              {config.label}
            </Typography>
          </Box>

          <Box sx={VALUE_BOX_STYLE}>
            <Typography
              fontSize={CHART_TYPOGRAPHY.body5.fontSize}
              fontWeight={600}
              color="#373D41"
              noWrap
            >
              {formatValue(value, config.format)}
            </Typography>
          </Box>
        </Flex>
      )}
    </Box>
  );
};

const BillingReportKPICards = ({
  data,
  isLoading,
}: BillingReportKPICardsProps) => {
  return (
    <Flex gap="12px" flexWrap="wrap">
      {BILLING_KPI_CARDS.map((card) => (
        <KPICard
          key={card.key}
          config={card}
          data={data}
          isLoading={isLoading}
        />
      ))}
    </Flex>
  );
};

export default BillingReportKPICards;
